import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Dimensions,
  TouchableOpacity,
  Image,
  Modal,
  Pressable,
} from "react-native";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import DrawerToptab from "./DrawerToptab";

const { height, width } = Dimensions.get("window");
const ReportDrawer = ({ navigation }) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <SafeAreaView style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
      <View
        style={{
          width: "100%",

          flexDirection: "row",

          alignItems: "center",

          backgroundColor: AppColors.white,

          height: 58,

          justifyContent: "space-between",

          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{
              height: 30,
              width: 30,
              justifyContent: "center",
              backgroundColor: "white",
            }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>

          <Text
            style={{
              color: AppColors.brown1,

              fontSize: 16,

              fontFamily: AppFonts.OverpassSemiBold,

              fontWeight: "500",
            }}
          >
            Reports
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",

            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => setModalVisible(true)}>
            <Image
              source={AppImages.Plus}
              style={{ width: 18, height: 18, marginLeft: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          setModalVisible(!modalVisible);
        }}
      >
        <Pressable
          onPress={() => setModalVisible(false)}
          style={{
            flex: 1,
            backgroundColor: "rgba(66, 31, 0, 0.5)",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.white,
              width: "100%",
              padding: 20,
              borderTopLeftRadius: 15,
              borderTopRightRadius: 15,
            }}
          >
            <View
              style={{
                height: 2,
                width: 65,
                backgroundColor: AppColors.brown,
                marginBottom: 10,
                alignSelf: "center",
                //marginTop: 10,
                borderRadius: 10,
              }}
            ></View>
            <Text
              style={{
                color: AppColors.brown,
                fontFamily: AppFonts.OverpassBold,
                fontSize: 18,
                textAlign: "left",
              }}
            >
              Add Report
            </Text>
            <View
              style={{
                borderWidth: 0.5,
                borderColor: AppColors.sandal,
                marginVertical: 10,
                marginHorizontal: 20,
              }}
            ></View>
            <View style={{}}>
              <TouchableOpacity
                onPress={() => [
                  setModalVisible(false),
                  navigation.navigate("ScheduleRepo"),
                ]}
              >
                <Text
                  style={{
                    color: AppColors.dualbrown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 16,
                    marginBottom: 20,
                    marginTop: 10,
                  }}
                >
                  Schedule Report
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => [
                  setModalVisible(false),
                  navigation.navigate("CustomRepo"),
                ]}
              >
                <Text
                  style={{
                    color: AppColors.dualbrown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 16,
                  }}
                >
                  Custom Report
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </Pressable>
      </Modal>
      <DrawerToptab />
    </SafeAreaView>
  );
};

export default ReportDrawer;

const styles = StyleSheet.create({});
